export default __webpack_public_path__ + "static/media/img-clients_8.79415c68.png";